import { useState } from "react";
import { heroStats, heroHotTags } from "@/mocks/homeData";

export default function HeroSection() {
  const [keyword, setKeyword] = useState("");

  return (
    <section id="top" className="relative w-full overflow-hidden bg-foreground-950">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20moody%20abstract%20editorial%20background%20with%20deep%20crimson%20smoke%20and%20charcoal%20texture%2C%20dramatic%20side%20spotlight%2C%20subtle%20film%20grain%2C%20high%20contrast%2C%20no%20people%2C%20artistic%20abstract%20composition&width=1600&height=900&seq=h18herobg&orientation=landscape"
          alt="18黑料网关键词索引背景"
          title="18黑料网 黑料关键词搜索与热点词索引"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/70 to-foreground-950/90"></div>
      </div>

      <div className="relative z-10 w-full px-4 pb-14 pt-20 md:px-6 md:pb-20 md:pt-28 lg:pt-32">
        <div className="mx-auto max-w-4xl text-center">
          <p className="animate-fade-up mb-5 inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3.5 py-1.5 text-xs font-medium text-background-100 md:text-sm">
            <span className="flex h-3.5 w-3.5 items-center justify-center text-accent-400">
              <i className="ri-fire-line text-base" aria-hidden="true"></i>
            </span>
            黑料关键词索引 · 热点词每日多次刷新
          </p>

          <h2 className="animate-fade-up font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl lg:text-6xl">
            输入一个关键词，
            <br className="hidden sm:block" />
            把散落的<span className="text-accent-400">黑料线索</span>收成一束
          </h2>

          <p className="animate-fade-up mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-background-200 md:mt-6 md:text-base">
            18黑料网以关键词为核心，把公开传播的热点词、人物争议与专题合集按检索维度重新索引。
            你只需要一个名字、一个词，就能沿着时间线，逐条定位到你关心的目标人物负面信息。
          </p>

          <form
            id="hero-search"
            className="animate-fade-up mx-auto mt-8 flex w-full max-w-2xl flex-col items-stretch gap-2 sm:flex-row md:mt-10"
            onSubmit={(event) => event.preventDefault()}
            role="search"
          >
            <div className="flex h-12 flex-1 items-center gap-2.5 rounded-md border border-background-50/20 bg-background-50/95 px-4 md:h-14">
              <span className="flex h-5 w-5 items-center justify-center text-foreground-500">
                <i className="ri-search-2-line text-lg" aria-hidden="true"></i>
              </span>
              <input
                type="text"
                name="heroKeyword"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="输入人物称呼、事件或热点词，如：塌房"
                className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500 md:text-base"
              />
            </div>
            <button
              type="submit"
              className="h-12 cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:h-14 md:px-8 md:text-base"
            >
              开始检索
            </button>
          </form>

          <div className="animate-fade-up mt-5 flex flex-wrap items-center justify-center gap-2">
            <span className="text-xs text-background-300 md:text-sm">大家都在搜：</span>
            {heroHotTags.map((tag) => (
              <button
                key={tag}
                type="button"
                onClick={() => setKeyword(tag)}
                className="cursor-pointer whitespace-nowrap rounded-full border border-background-50/20 bg-background-50/10 px-3 py-1 text-xs text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300 md:text-sm"
              >
                {tag}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="relative z-10 w-full border-t border-background-50/10 bg-foreground-950/60 px-4 md:px-6">
        <div className="mx-auto grid max-w-6xl grid-cols-2 gap-x-4 gap-y-6 py-8 md:grid-cols-4 md:py-10">
          {heroStats.map((stat) => (
            <div key={stat.label} className="text-center md:text-left">
              <p className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
                {stat.value}
                <span className="ml-1 text-xs font-normal text-background-300 md:text-sm">{stat.unit}</span>
              </p>
              <p className="mt-1 text-xs text-background-300 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}